import { Component, OnInit } from '@angular/core';
import { NeoRol } from '../../../../comun/models/neoRol';
import { NeoRolService } from '../../../../comun/services/neoRol.service';
import { ParametrosService } from '../../../../services/parametros.service';
import { Departamento } from '../../../../comun/models/departamento';
import { Ciudad } from '../../../../comun/models/ciudad';
import { NeoUsuarioIntermediario } from '../../../Model/neoUsuarioIntermediario';
import { NeoTipoDocIdentidadService } from '../../../../comun/services/neoTipoDocIdentidad.service';
import { NeoTipoDocIdentidad } from '../../../../comun/models/neoTipoDocIdentidad';
import { Router } from '@angular/router';
import { NeoIntermediarioFinancieroService } from '../../../Service/neoIntermediarioFinanciero.service';
import { NeoUsuarioXRol } from '../../../Model/neoUsuarioXRol';
import { UntypedFormGroup, UntypedFormBuilder, Validators, UntypedFormControl } from '@angular/forms';
import { AlertService } from '../../../../services/alert.service';
import { UserService } from '../../../../services/user.service';
import { SweetAlertService } from 'src/app/services/sweet-alert.service';
declare var $: any;

@Component({
    selector: 'app-crear-usuario-if',
    templateUrl: './crear-usuario-if.component.html',
    styleUrls: ['./crear-usuario-if.component.scss'],
    providers: [
        NeoRolService,
        ParametrosService,
        NeoTipoDocIdentidadService,
        NeoIntermediarioFinancieroService,
    ],
    standalone: false
})
export class CrearUsuarioIFComponent implements OnInit {
  listaDocumentos: NeoTipoDocIdentidad[] = [];
  rolesDisponibles: UntypedFormControl = new UntypedFormControl('');
  rolesSeleccionados: UntypedFormControl = new UntypedFormControl('');
  listaRoles: NeoRol[] = [];
  listaRolesSeleccionados: NeoRol[] = [];
  listaRolesSeleccionadosId: Number[] = [];
  public departamentos: Departamento[] = [];
  public listDepartamentos: Departamento[] = [];
  public ciudades: Ciudad[] = [];
  public neoUsuario: NeoUsuarioIntermediario;
  public neoUsuarioXRol: NeoUsuarioXRol;
  public user;

  crearUsuarioIFForm: UntypedFormGroup;
  /** Patrón lineal para evitar ReDoS; valida estructura local@dominio.ext */
  correoElectronicoFormato = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // NOSONAR - regex lineal, sin backtracking


  constructor(
    private _neoIntermediarioFinancieroService: NeoIntermediarioFinancieroService,
    private _neoRolService: NeoRolService,
    private _parametrosService: ParametrosService,
    private _neoTipoDocIdentidadService: NeoTipoDocIdentidadService,
    public router: Router,
    private _userIntermediarioService: UserService,
    private formBuilder: UntypedFormBuilder,
    private alertService: AlertService,
    private _sweetAlert:SweetAlertService
  ) {
    this.user = this._userIntermediarioService.getUser();
    this.neoUsuario = new NeoUsuarioIntermediario(
      '',
      '',
      '',
      '',
      '',
      '',
      null,
      null,
      null,
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      null,
      null,
      '',
      null,
      null,
      null,
      null
    );
    this.neoUsuarioXRol = new NeoUsuarioXRol(
      this.neoUsuario,
      this.listaRolesSeleccionadosId
    );
    this.crearUsuarioIFForm = this.formBuilder.group({
      areaCompania: [''],
      cargo: ['', Validators.required],
      celular: ['', Validators.required],
      correoElectronico: [
        '',
        [
          Validators.required,
          Validators.pattern(this.correoElectronicoFormato),
        ],
      ],
      direccion: [''],
      extension: [''],
      idCiudad: ['', Validators.required],
      idDepartamento: ['', Validators.required],
      idUsuarioRegistro: [0],
      numeroDocumento: ['', Validators.required],
      primerApellido: ['', Validators.required],
      primerNombre: ['', Validators.required],
      segundoApellido: [''],
      segundoNombre: [''],
      telefonoFijo: [''],
      idCliente_NeoCliente: [0],
      idTipoDocIdentidad_NeoTipoDocIdentidad: ['', Validators.required],
      sucursalOficina: ['', Validators.required],
      ventaIncialAtendido: [null],
      ventaFinalAtendido: [null],
      departamentosSeleccionados: [null],
      aplicaTodosDepartamentos: false
    });
  }

  comparerRol(a: NeoRol, b: NeoRol) {
    if (a.nombre.toLowerCase() < b.nombre.toLowerCase()) {
      return -1
    } else if (a.nombre.toLowerCase() > b.nombre.toLowerCase()) {
      return 1
    } else {
      return 0
    }
  }

  ngOnInit(): void {
    this.formatPipe();
    this._neoIntermediarioFinancieroService.getListDepartamentosUbicaciones(this.user.idCliente).subscribe((resp: any) => {
      this._parametrosService.getDepartamentos('169').subscribe(
        (response) => {
          this.departamentos = response['data'];
          this.listDepartamentos = this.departamentos.filter((item: any) => resp.data.includes(item.idDepartamento));
        },
        (error) => {
          this._sweetAlert.errorModal("Error!", true, 'Error al cargar los departamentos');
        }
      );
    });
    this._neoRolService.getRolesIF().subscribe(
      (response) => {
        this.listaRoles = response['roles'];
      },
      (error) => {
        this._sweetAlert.errorModal("Error!",true,'Error al cargar los roles');
      },
      () => {
        setTimeout(() => {
          $('.selectpicker').selectpicker('refresh');
        });
      }
    );

    this._neoTipoDocIdentidadService.getTiposDocIdentidad().subscribe(
      (response) => {
        this.listaDocumentos = response.filter(
          (documento) => documento.idTipoDocIdentidad != 1 && documento.idTipoDocIdentidad != 4 && documento.idTipoDocIdentidad != 6
        );
      },
      (error) => {
        this._sweetAlert.errorModal("Error!",true,'Error al cargar los tipos de documento');
      }
    );
  }

  isValidForm(field: string) {
    return (
      (this.crearUsuarioIFForm.get(field)?.dirty ||
        this.crearUsuarioIFForm.get(field)?.touched) &&
      this.crearUsuarioIFForm.get(field)?.invalid
    );
  }

  validateLetters(event: any) {
    const pattern = /[a-zA-Z áéíóúÁÉÍÓÚñÑ@&._$-]+/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
  validateNumber(event: any) {
    const pattern = /[0-9]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
  validateDocument(event: any) {
    if (this.crearUsuarioIFForm.get('idTipoDocIdentidad_NeoTipoDocIdentidad').value == 5 ||
      this.crearUsuarioIFForm.get('idTipoDocIdentidad_NeoTipoDocIdentidad').value == 3) {
      const pattern = /[a-zA-Z0-9]/;
      let inputChar = String.fromCharCode(event.charCode);
      if (!pattern.test(inputChar)) {
        event.preventDefault();
      }
    } else {
      this.validateNumber(event);
    }
  }
  validarSelect() {
    this.crearUsuarioIFForm.get('numeroDocumento').setValue('');
  }

  getCiudades(idDepartamento) {
    this.crearUsuarioIFForm.get('idCiudad').setValue('');
    if (idDepartamento != 'null' && idDepartamento != '') {
      this._parametrosService.getCiudades(idDepartamento).subscribe(
        (response) => {
          this.ciudades = response['data'];
        },
        (error) => {
          this._sweetAlert.errorModal("Error!",true,'Error al cargar las ciudades');
        }
      );
    } else {
      this.ciudades = [];
    }
  }

  crearUsuario() {
    this.neoUsuario = this.crearUsuarioIFForm.value;
    this.neoUsuario.idTipoDocIdentidad_NeoTipoDocIdentidad = Number(
      this.crearUsuarioIFForm.get('idTipoDocIdentidad_NeoTipoDocIdentidad')
        .value
    );
    this.neoUsuario.idDepartamento = Number(
      this.crearUsuarioIFForm.get('idDepartamento').value
    );
    this.neoUsuario.idCiudad = Number(
      this.crearUsuarioIFForm.get('idCiudad').value
    );
    this.neoUsuario.ventaIncialAtendido = (this.crearUsuarioIFForm.get('ventaIncialAtendido').value != null &&
     this.crearUsuarioIFForm.get('ventaIncialAtendido').value != '') ? +this.crearUsuarioIFForm
      .get('ventaIncialAtendido').value.replace(/[.]/g, ''): null;
    this.neoUsuario.ventaFinalAtendido = (this.crearUsuarioIFForm.get('ventaFinalAtendido').value != null &&
    this.crearUsuarioIFForm.get('ventaFinalAtendido').value != '') ? +this.crearUsuarioIFForm
      .get('ventaFinalAtendido').value.replace(/[.]/g, ''): null;
    if (
      this.neoUsuario.idDepartamento != 0 &&
      this.neoUsuario.idTipoDocIdentidad_NeoTipoDocIdentidad != 0 &&
      this.neoUsuario.idCiudad != 0
    ) {
      if (this.listaRolesSeleccionados.length > 0) {
        if (this.user.idCliente != null && this.user.idUsuario != null) {
          if (this.neoUsuario.ventaIncialAtendido != null && this.neoUsuario.ventaFinalAtendido != null
            && (this.neoUsuario.ventaIncialAtendido > this.neoUsuario.ventaFinalAtendido)
          ) {
            this._sweetAlert.errorModal("Error!", true,
              "El valor 'Monto de ventas final atendido' no puede ser menor al valor 'Monto de ventas inicial atendido'.");
          } else if ((this.neoUsuario.ventaIncialAtendido == null && this.neoUsuario.ventaFinalAtendido != null) ||
            (this.neoUsuario.ventaIncialAtendido != null && this.neoUsuario.ventaFinalAtendido == null)) {
            this._sweetAlert.errorModal("Error!", true, "Debes diligenciar ambos valores del monto atendido.");
          } else {
            this.neoUsuario.idUsuarioRegistro = this.user.idUsuario;
            this.neoUsuario.idCliente_NeoCliente = this.user.idCliente;
            this.neoUsuarioXRol.usuario = this.neoUsuario;
            this.idRolesFormulario();
            this.neoUsuarioXRol.roles = this.idRoles();
            this._neoIntermediarioFinancieroService
              .saveUsuario(this.neoUsuarioXRol)
              .toPromise()
              .then((result) => {
                if (result.exitoso == true) {
                  this._sweetAlert.successModal('¡Éxito!',
                    false,
                    'El usuario ha sido creado exitosamente').then(
                      (result) => {
                        if (result.isConfirmed) {
                          this.router.navigate(['/intermediario/home']);
                        }
                      });
                  // $('#aceptarModal').modal('show');
                } else {
                  this._sweetAlert.errorModal("Error!", true, result.error);
                }
              })
              .catch((err) => {
                this._sweetAlert.errorModal("Error!", true, 'Error al crear usuario');
              });
          }        
        } else {
          this._sweetAlert.errorModal("Error!",true,'Problema al cargar el usuario');
        }
      } else {
        this._sweetAlert.errorModal("Error!",true,'Seleccione los roles para usuario');
      }
    } else {
      this._sweetAlert.errorModal("Error!",true,'Faltan campos por seleccionar');
    }
  }

  aceptar() {
    $('#aceptarModal').modal('hide');
    this.router.navigate(['/intermediario/home']);
  }

  cancelar() {
    this.router.navigate(['/intermediario/home']);
  }

  addRol() {
    if(this.rolesDisponibles.value != ''){
      this.rolesDisponibles.value.map((id) => {
        const rol = this.listaRoles.find((roles) => roles.idRol == id);
        this.listaRolesSeleccionados.push(rol);
        this.listaRoles = this.listaRoles.filter((roles) => roles.idRol !== id);
      });
      this.rolesDisponibles.setValue('');
      this.listaRolesSeleccionados.sort(this.comparerRol);
      this.listaRoles.sort(this.comparerRol);
      this.refreshRol('#addRoles');
    }else{
      this._sweetAlert.errorModal("Error!",true,'Selecciona roles asignar.');
    }

  }

  addRolAll() {
    if(this.listaRoles.length != 0){
      this.listaRolesSeleccionados = this.listaRolesSeleccionados.concat(
        this.listaRoles
      );
      this.listaRoles = [];
      this.listaRolesSeleccionados.sort(this.comparerRol);
      this.refreshRol('#addRoles');
    }else{
      this._sweetAlert.errorModal("Error!",true,'No tienes roles para asignar.');
    }
  }

  removeRol() {
    if(this.rolesSeleccionados.value != ''){
      this.rolesSeleccionados.value.map((id) => {
        const rol = this.listaRolesSeleccionados.find(
          (roles) => roles.idRol == id
        );
        this.listaRoles.push(rol);
        this.listaRolesSeleccionados = this.listaRolesSeleccionados.filter(
          (roles) => roles.idRol !== id
        );
        this.rolesDisponibles.setValue(this.idRoles());
        this.listaRolesSeleccionados.sort(this.comparerRol);
        this.listaRoles.sort(this.comparerRol);
      });
      this.rolesSeleccionados.setValue('');
      this.refreshRol('#deleteRole');
    }else{
      this._sweetAlert.errorModal("Error!",true,'Selecciona roles a eliminar.');
    }
  }

  removeRolAll() {
    if(this.listaRolesSeleccionados.length != 0){
      this.listaRoles = this.listaRoles.concat(this.listaRolesSeleccionados);
      this.listaRolesSeleccionados = [];
      this.rolesSeleccionados.setValue('');
      this.listaRoles.sort(this.comparerRol);
      this.refreshRol('#deleteRoles');
    }else{
      this._sweetAlert.errorModal("Error!",true,'No tienes roles a eliminar.');
    }
  }

  refreshRol(select: any){
    setTimeout(() => {
      $('.selectpicker').selectpicker('refresh');
      $(select).val('');
    });
  }

  idRolesFormulario() {
    this.listaRolesSeleccionados.forEach((rol) => {
      this.listaRolesSeleccionadosId.push(rol.idRol);
    });
  }

  idRoles(): Number[] {
    let ids: Number[] = [];
    this.listaRolesSeleccionados.map((roles) => ids.push(roles.idRol));
    return ids;
  }

  formatPipe(){
    this.setPipeForm('ventaIncialAtendido');    
    this.setPipeForm('ventaFinalAtendido');
  }

  setPipeForm(controlName: string) {
    const control = this.crearUsuarioIFForm.get(controlName);
    if (control) {      
      control.valueChanges.subscribe(value => {
        if (value !== null && value !== '') {
          const nuevoValor = this.cambiarFormatoNumero(value);
          control.patchValue(nuevoValor, { emitEvent: false });
        }
      });
    }     
  }

  cambiarFormatoNumero(value: any): string {
    let stringValue = String(value).replace(/[^\d]/g, '');
    stringValue = stringValue.replace(/^0+/, '');
    const parts = stringValue.split('.');
    parts[0] = this.formatThousandsSeparator(parts[0], '.');
    return parts.join('.');
  }

  /** Formato miles sin regex vulnerable (evita ReDoS). */
  private formatThousandsSeparator(s: string, sep: string): string {
    if (!s) return s;
    let out = '';
    for (let i = 0; i < s.length; i++) {
      if (i > 0 && (s.length - i) % 3 === 0) out += sep;
      out += s[i];
    }
    return out;
  }

  actualizarDepartamentos() {
    if (this.crearUsuarioIFForm.controls.aplicaTodosDepartamentos.value) {
      this.crearUsuarioIFForm.get('departamentosSeleccionados').setValue(null);
      setTimeout(() => {
        $('#departamentosSeleccionados').val('');
        $('#departamentosSeleccionados').prop('disabled', true);
        $('.selectpicker').selectpicker('refresh');
      });
    } else {
      setTimeout(() => {
        $('#departamentosSeleccionados').prop('disabled', false);
        $('.selectpicker').selectpicker('refresh');
      });
    }
  }
}
